<template>
	<div style="padding: 10px;">
		<div style="">
			<div style="min-width: 120px;float: right;margin-right: 20px;margin-bottom: 10px;">
				<!-- <el-button type="primary" @click="searchSysConfig" icon="el-icon-search">搜索</el-button> -->
				<!-- <el-button  icon="el-icon-refresh" @click="queryData">刷新</el-button> -->
				<el-button type="primary" icon="el-icon-plus" @click="addOrg">新增</el-button>
				<el-button type="warning" icon="el-icon-refresh" @click="restartShow = true">重启采集器</el-button>
			</div>
		</div>
		
		<!-- <el-row :gutter="20">
			<el-col :span="20"> 
				<el-select style="width: 100%;" v-model="searchInfo.id" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
				<el-input clearable placeholder="请选择校区" v-model="searchInfo.id">
					<template slot="prepend">配置名称</template>
				</el-input> 
			</el-col>
			<el-col :span="4"> 
				
			</el-col>
		</el-row> -->
		<div style="margin-top: 10px;">
			<div style="">  <!-- max-height: 700px;overflow: auto; -->
				<el-table max-height='700' :data="orgList" style="width: 100%" row-key="id" border lazy :load="queryData"
					:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column prop="name" label="名称" align="left" > </el-table-column>
					<el-table-column prop="id" label="编码" align="center" width="200"> </el-table-column>
					<el-table-column prop="type" label="类型" align="center" width="150"> </el-table-column>
					<el-table-column prop="idx" label="排序" align="center" width="150"> </el-table-column>
					<el-table-column prop="picurl" label="图片" align="center">
						<template slot-scope="scope">
							<el-image v-if="scope.row.picurl" style="width: 100px; height: 80px" lazy :src="scope.row.picurl" fit="fill"></el-image>
						</template>
					</el-table-column>
					<el-table-column fixed="right" prop="op" label="操作" width="320" align="center">
						<template slot-scope="scope">
							<a @click="goOrgDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
								<i class="el-icon-Stall">详情</i>
							</a>
							<a @click="goOrgPointDetail(scope.$index, scope.row)" title="点位" style="display:inline-block;cursor:pointer;color: #67C23A;margin-left: 20px;">
								<i class="el-icon-Stall">点位</i>
							</a>
							<a @click="deleteDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
								<i class="el-icon-Stall">删除</i>
							</a>
							<a @click="autoCreateLoginDev(scope.$index, scope.row)" title="创建逻辑内机" style="display:inline-block;cursor:pointer;color: #E6A23C;margin-left: 20px;">
								<i class="el-icon-Stall">创建逻辑内机</i>
							</a>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<OrgDetail ref="orgdetail" @needRefrash="needRefrash" :add="isadd" :selectorg="selectset"></OrgDetail>
		</el-dialog>
		<el-dialog :destroy-on-close="true" title="关联的点位" width="70%" :visible.sync="detailPointShow">
			<OrgPoint :selectedorg="selectset"></OrgPoint>
		</el-dialog>
		<el-dialog :destroy-on-close="true" title="重启采集器" width="70%" :visible.sync="restartShow">
			<div>
				<el-form :inline="false" ref="restartrule" label-width="120px" class="">
					<el-row>
						<el-col :span="10">
							<el-form-item label="采集器IP" prop="ip">
								<el-input clearable placeholder="采集器IP" v-model="restartData.ip">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="采集器端口" prop="port">
								<el-input clearable placeholder="采集器端口" v-model="restartData.port">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="4">
							<div style="min-width: 100px;text-align: center;">
								<el-button type="primary" @click="restartTcpGather" icon="el-icon-refresh">重启</el-button>
							</div>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { queryOrgByParent,deleteOrgById, autoCreateAirIn, restartGatherDocker } from '/static/apiUrl.js'
	import { baseUrl, nfsprefix } from '/public/baseUrl.js'
	import OrgDetail from './orgdetail'
	import OrgPoint from './orgpoint'
	export default {
		name : 'OrgTree',
		data() {
			return {
				detailShow: false,
				restartShow : false,
				editok : false,
				isadd : false,
				detailTitle: '组织详情',
				detailPointShow : false,
				selectset: null,	
				searchInfo:{
					name: '',
					id : '',
				},
				restartData :{
					ip: "",
					port : '',
				},
				orgList : [],
				logicdevcreate: {
					orgid : '',
					orgname : '',
					devtype : "",
				}
			}
		},
		mounted() {
			this.queryData()
		},
		components: {
			OrgDetail,
			OrgPoint,
		},
		methods: {
			queryData(tree, treeNode, resolve){
				if(tree == undefined || tree == null || tree == ''){
					this.orgList = []
				}
				console.log(tree,treeNode)
				queryOrgByParent({
					pid : (tree == undefined || tree == null) ? '' : tree.id
				}).then(res => {
					if(0 == res.code){
						if(tree == undefined || tree == null || tree == ''){
							res.datas.forEach((item) => {
								let ty = ""
								if("XQ" == item.type){
									ty = "校区"
								}else if("JG" == item.type){
									ty = "机构"
								}
								this.orgList.push({
									id : item.id,
									name : item.name,
									parentid : item.parentid,
									type : ty,
									typecode : item.type,
									idx : item.idx,
									picurl : (item.picurl == null || item.picurl == '') ? null : baseUrl+nfsprefix+item.picurl,
									hasChildren : item.hasChildren,
									children : []
								})
							})
						}else{
							//tree.children = []
							let child = []
							res.datas.forEach((item) => {
								let ty = ""
								if("XQ" == item.type){
									ty = "校区"
								}else if("JG" == item.type){
									ty = "机构"
								}
								child.push({
									id : item.id,
									name : item.name,
									parentid : item.parentid,
									type : ty,
									typecode : item.type,
									idx : item.idx,
									picurl : (item.picurl == null || item.picurl == '') ? null : baseUrl+nfsprefix+item.picurl,
									opic : item.picurl,
									hasChildren : item.hasChildren
								})
							})
							if(resolve)
								resolve(child)
						}
					}
				})
			},
			addOrg(){
				this.detailTitle = "新增组织"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
				setTimeout(() => {
					this.$refs.orgdetail.initOrgTree()
				}, 200)
			},
			goOrgDetail(idx,row){
				this.detailTitle = '组织详情'
				this.isadd = false
				this.selectset = JSON.parse(JSON.stringify(row))
				console.log(this.selectset)
				this.detailShow = true
				setTimeout(() => {
					this.$refs.orgdetail.initOrgTree()
				}, 200)
			},
			goOrgPointDetail(idx,row){
				this.selectset = JSON.parse(JSON.stringify(row))
				this.detailPointShow = true
			},
			needRefrash(val,isshow){
				console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryData()
				}
			},
			deleteTreeNode(id){
				function removeNodeById(nodes, id) {
					for (let i = 0; i < nodes.length; i++) {
						if (nodes[i].id === id) {
							nodes.splice(i, 1); // 删除节点
							return true; // 找到并删除，结束递归
						} else if (nodes[i].children && nodes[i].children.length > 0) {
							return removeNodeById(nodes[i].children, id)
							/* if (removeNodeById(nodes[i].children, id)) {
								if (nodes[i].children.length === 0) {
									delete nodes[i].children; // 如果子节点被清空，可以删除children属性
								}
								return true; // 在子节点中找到并删除，结束递归
							} */
						}
					}
					return false; // 没有找到节点
				}
				removeNodeById(this.orgList, id);
				console.log(this.orgList)
				this.$forceUpdate()
			},
			deleteDetail(idx,row){
				this.$confirm('此操作将删除组织 '+row.name+'以及字节组织, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteOrgById({
						id : row.id
					}).then(res => {
						if(0 == res.code){
							this.queryData()
							//this.deleteTreeNode(row.id)
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			autoCreateLoginDev(idx,row){
				this.logicdevcreate.orgid = row.id
				this.logicdevcreate.orgname = row.name
				this.$confirm('确定为'+row.name+'创建空调内机的逻辑设备吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					autoCreateAirIn({
						oid : row.id
					}).then(res => {
						if(0 == res.code){
							this.$message({
								showClose: true,
								message: "创建成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			restartTcpGather(){
				if(this.restartData.ip == '' || this.restartData.port == ''){
					this.$message({
						showClose: true,
						message: "ip和端口必填",
						type: 'error'
					});
					return;
				}
				this.$confirm('确定重启'+this.restartData.ip+'端口：'+this.restartData.port+'的采集器吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					restartGatherDocker(this.restartData).then(res => {
						if(0 == res.code){
							this.$message({
								showClose: true,
								message: res.message,
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>